import { Link } from "react-router-dom";
const IntegrationsPage = () => {
  return (
    <div>
      <h1>Integrations</h1>
      <Link to="/googleforms-notion">FormsNotion</Link>
    </div>
  );
};

export default IntegrationsPage;
